// @flow

import stores from 'stores';

export default (query: string) => {
  return stores.parcelsStore.searchForReturns(query);
};
